import React from "react";
import ReactFlow, { Edge, Node } from "reactflow";
import "reactflow/dist/style.css";

type Props = {
  nodes: Node[];
  edges: Edge[];
  nodeTypes: any;
  partitionMode: boolean;
  onEdgeClick: (e: React.MouseEvent, edge: Edge) => void;
};

export default function RFOverlay({
  nodes,
  edges,
  nodeTypes,
  partitionMode,
  onEdgeClick,
}: Props) {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        zIndex: 2,
        pointerEvents: partitionMode ? "none" : "auto",
      }}
    >
      <ReactFlow
        nodes={nodes}
        edges={edges}
        nodeTypes={nodeTypes}
        fitView={false}
        defaultViewport={{ x: 0, y: 0, zoom: 1 }}
        minZoom={1}
        maxZoom={1}
        panOnDrag={false}
        panOnScroll={false}
        zoomOnScroll={false}
        zoomOnPinch={false}
        zoomOnDoubleClick={false}
        nodesDraggable={false}
        nodesConnectable={!partitionMode}
        elementsSelectable={!partitionMode}
        edgesFocusable={!partitionMode}
        onEdgeClick={onEdgeClick}
        defaultEdgeOptions={{ interactionWidth: 24 }}
        proOptions={{ hideAttribution: true }}
        style={{ width: "100%", height: "100%", background: "transparent" }}
      />
    </div>
  );
}
